import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Grid, TextField, MenuItem, FormControl, InputLabel, Select, Button, Avatar } from "@mui/material";
import * as EcommerceActions from '../../../redux/actions/ecommerceAction.js';
import { UploadImageSvg } from "../../../assets/svg/index.js";

const AddSubCategory = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { ecommerceCategoryData } = useSelector(state => state.ecommerceReducer);

  const [subCategoryDetail, setSubCategoryDetail] = useState({ categoryId: '', subCategoryName: '' });
  const [inputFieldError, setInputFieldError] = useState({ categoryId: '', subCategoryName: '', image: '' });
  const [image, setImage] = useState({ file: '', bytes: '' });

  //* Handle Input Field : Error
  const handleInputFieldError = (input, value) => {
    setInputFieldError((prev) => ({ ...prev, [input]: value }))
  }

  //* Handle Input Field : Data
  const handleInputField = (e) => {
    const { name, value } = e.target;
    setSubCategoryDetail({ ...subCategoryDetail, [name]: value });
  };

  //! Handle Image : Normally
  const handleImage = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setImage({
        file: URL.createObjectURL(e.target.files[0]),
        bytes: e.target.files[0],
      });
    }

    handleInputFieldError("image", null)
  };

  //! Handle Image : Drop Feature
  const handleDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      setImage({
        file: URL.createObjectURL(e.dataTransfer.files[0]),
        bytes: e.dataTransfer.files[0],
      });
    }

    handleInputFieldError("image", null)
  };

  //! Handle Validation
  const handleValidation = () => {
    let isValid = true;
    const { subCategoryName, categoryId } = subCategoryDetail;
    const { bytes } = image;

    if (!categoryId) {
      handleInputFieldError("categoryId", "Please Select Category Name")
      isValid = false;
    }
    if (!subCategoryName) {
      handleInputFieldError("subCategoryName", "Please Enter Sub Category Name")
      isValid = false;
    }
    if (!bytes) {
      handleInputFieldError("image", "Please Select Image")
      isValid = false;
    }
    return isValid;
  };

  //! Handle Submit - Creating Sub Category
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      console.log("Sub Category Data :: ", { ...subCategoryDetail, image })
      const { categoryId, subCategoryName } = subCategoryDetail;

      let formData = new FormData()
      formData.append("productCategoryId", categoryId)
      formData.append("product_sub_category_name", subCategoryName)
      formData.append("image", image?.bytes);

      const payload = {
        data: formData,
        onComplete: () => navigate("/e-commerce/sub-category")
      }

      //! Dispatching API for Creating Banner
      dispatch(EcommerceActions.createEcommerceSubCategory(payload))
    }
  };

  useEffect(() => {
    //! Dispatching API for Getting Category
    dispatch(EcommerceActions.getEcommerceCategory())
  }, []);

  return (
    <>
      <div style={{ padding: "20px", backgroundColor: "#fff", marginBottom: "20px", boxShadow: '0px 0px 5px lightgrey', borderRadius: "10px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px", fontFamily: 'Philosopher', backgroundColor: "#fff" }}>
          <div style={{ fontSize: "20px", fontWeight: "600", color: "#667284" }}>Add Ecommerce Sub Category</div>
          <div onClick={() => navigate("/e-commerce/sub-category")} style={{ fontWeight: "600", backgroundColor: "#164E62", color: "#fff", padding: "5px 10px", borderRadius: "5px", cursor: "pointer", fontSize: "14px" }}>Display</div>
        </div>

        <Grid container sx={{ alignItems: "center" }} spacing={3}>
          <Grid item lg={12} sm={12} md={12} xs={12} >
            <div style={{ color: "#000", border: "1px solid #C4C4C4", borderRadius: "3px" }}>
              {image?.bytes ?
                <label onDragOver={(e) => e.preventDefault()} onDrop={handleDrop} htmlFor="upload-image" style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "20px", cursor: "pointer" }}>
                  <Avatar src={image.file} style={{ height: '300px', width: "300px", borderRadius: "initial" }} />
                </label>
                :
                <label onDragOver={(e) => e.preventDefault()} onDrop={handleDrop} htmlFor="upload-image" style={{ display: "flex", flexDirection: "column", gap: "20px", alignItems: "center", padding: "100px 0", cursor: "pointer" }}>
                  <UploadImageSvg h="80" w="80" color="#C4C4C4" />
                  <div style={{ fontWeight: "600", fontSize: "18px" }}>Choose Your Image to Upload</div>
                  <div style={{ fontWeight: "500", fontSize: "16px", color: 'grey' }}>Or Drop Your Image Here</div>
                </label>}
              <input id="upload-image" onChange={handleImage} hidden accept="image/*" type="file" />
            </div>
            {inputFieldError?.image && <div style={{ color: "#D32F2F", fontSize: "10.75px", padding: "10px 0 0 12px", }}>{inputFieldError?.image}</div>}
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <FormControl fullWidth>
              <InputLabel id="select-label">Select Category Name</InputLabel>
              <Select
                label="Select Category Name" variant="outlined" fullWidth
                name='categoryId'
                value={subCategoryDetail?.categoryId}
                onChange={handleInputField}
                error={inputFieldError?.categoryId ? true : false}
                onFocus={() => handleInputFieldError("categoryId", null)}
              >
                <MenuItem disabled>---Select Category Name---</MenuItem>
                {ecommerceCategoryData && ecommerceCategoryData.map((value, index) => {
                  return <MenuItem key={index} value={value?._id}>{value?.title}</MenuItem>
                })}
              </Select>
            </FormControl>
            {inputFieldError?.categoryId && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "3px 15px 0 15px" }}>{inputFieldError?.categoryId}</div>}
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <TextField
              label="Sub Category Name" variant='outlined' fullWidth
              name='subCategoryName'
              value={subCategoryDetail?.subCategoryName}
              onChange={handleInputField}
              error={inputFieldError.subCategoryName ? true : false}
              helperText={inputFieldError.subCategoryName}
              onFocus={() => handleInputFieldError("subCategoryName", null)}
            />
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container sx={{ justifyContent: "space-between" }}>
              <div onClick={handleSubmit} style={{ fontWeight: "500", backgroundColor: "#164E62", color: "#fff", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px" }}>Submit</div>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default AddSubCategory;